import { createSimpleEvent } from '@passionware/simple-event';
import {
  createActionAsEventMiddleware,
  V1Action
} from './actionAsEventMiddleware';
export const myV1ActionEvent = createSimpleEvent<V1Action>();

export const myActionAsEventMiddleware =
  createActionAsEventMiddleware(myV1ActionEvent);
